import elmntIO from './inc/elmnt-io.js';

export function siteFooter() {
    const $siteFooter = document.getElementById('site-footer');

    if (!$siteFooter) return;

    elmntIO($siteFooter, handleEnter, handleExit);

    const handleScroll = () => {
        // 100 at the top of the footer (entering the viewport), 0 at --percent-to-bottom-end from the page bottom
        const footerHeight = $siteFooter.offsetHeight;
        const footerTop = $siteFooter.getBoundingClientRect().top;
        const endOffset = parseFloat(getComputedStyle($siteFooter).getPropertyValue('--percent-to-bottom-end')) || 0;
        const remainingToBottom = footerTop + footerHeight - window.innerHeight - endOffset;
        const range = Math.max(footerHeight - endOffset, 1);
        const scrollToFooterPercentage = Number(Math.max(0, Math.min(100, (remainingToBottom / range) * 100)).toFixed(3));
        $siteFooter.style.setProperty('--percent-to-bottom', `${scrollToFooterPercentage}`);
    };

    function handleEnter() {
        handleScroll();
        window.addEventListener('scroll', handleScroll);
    }

    function handleExit() {
        window.removeEventListener('scroll', handleScroll);
    }
}


export function siteFooterInstaScrollIn() {
    const $footerInstaTicker = document.getElementById('footer-insta-ticker');

    if (!$footerInstaTicker || $footerInstaTicker.dataset.instaIoBound) return;

    $footerInstaTicker.dataset.instaIoBound = 'true';

    elmntIO($footerInstaTicker, handleEnter, handleExit);

    const handleScroll = () => {
        // 0 when the top of the element is at the bottom of the viewport, 1 when the full height is in view
        const rect = $footerInstaTicker.getBoundingClientRect();
        const entered = window.innerHeight - rect.top;
        const percentInViewport = Number(Math.max(0, Math.min(1, entered / rect.height)).toFixed(3));
        $footerInstaTicker.style.setProperty('--percent-in-viewport', `${percentInViewport}`);
    };

    function handleEnter() {
        handleScroll();
        window.addEventListener('scroll', handleScroll);
    }
    
    function handleExit() {
        window.removeEventListener('scroll', handleScroll);
    }
}